import React from 'react';
import { ExternalLink, SubduedLink } from 'src/components/links';
import { LabelValue, Layout, Panel, Stack } from 'src/components/matchbox';
import { SubduedText } from 'src/components/text';
import { EXTERNAL_LINKS } from '../constants';
import TlsStatusBadge from './TlsStatusBadge';

export default function TrackingDomainTLSCertificateSection({ domain, isSectionVisible }) {
  if (!isSectionVisible) {
    return null;
  }

  const { uses_managed_certificate: usesManagedCertificate, status } = domain;

  if (!usesManagedCertificate) {
    return null;
  }

  const verified = status?.verified ?? domain.verified;

  return (
    <Layout>
      <Layout.Section annotated>
        <Layout.SectionTitle as="h2">TLS certificate</Layout.SectionTitle>
        <Stack>
          <SubduedText fontSize="200">
            SparkPost automatically manages a TLS certificate for this tracking domain, enabling
            secure connections for click and open tracking.
          </SubduedText>
          <SubduedLink
            as={ExternalLink}
            to={EXTERNAL_LINKS.TRACKING_DOMAIN_DOCUMENTATION}
            fontSize="200"
          >
            Tracking Domain Documentation
          </SubduedLink>
        </Stack>
      </Layout.Section>
      <Layout.Section alignY="stretch">
        <Panel alignY="stretch">
          <Panel.Section>
            <LabelValue orientation="vertical">
              <LabelValue.Label>Certificate Status</LabelValue.Label>
              <LabelValue.Value>
                <TlsStatusBadge
                  tlsStatus={status?.tls_status}
                  usesManagedCertificate={usesManagedCertificate}
                  verified={verified}
                />
              </LabelValue.Value>
            </LabelValue>
          </Panel.Section>
        </Panel>
      </Layout.Section>
    </Layout>
  );
}
